import { BookingSlot } from "@cur8/rich-entity";
import { DateTime } from "luxon";
import { useMemo } from "react";
import { usePatientBookingsQuery } from "render/hooks/api/queries/usePatientBookingsQuery";
import { usePatientQuery } from "render/hooks/api/queries/usePatientQuery";
import { FullScreenPageLayout } from "render/ui/layout/FullScreenPageLayout";
import { CheckIn } from "./components/CheckIn";
import { NoSlot } from "./components/NoSlot";

export function CheckInView({ roomId }: { roomId: string }) {
  const patientQuery = usePatientQuery();
  const patientBookingsQuery = usePatientBookingsQuery();
  const findTodaysSlot = useMemo(() => {
    if (!patientBookingsQuery.data) {
      return null;
    }
    return patientBookingsQuery.data.pages
      .reduce<BookingSlot[]>((acc, val) => {
        acc.push(...val.items);
        return acc;
      }, [])
      .find((slot) =>
        slot.startTime.hasSame(DateTime.now().startOf("day"), "day")
      );
  }, [patientBookingsQuery.data]);

  if (!patientBookingsQuery.data || !patientQuery.data) {
    return <FullScreenPageLayout />;
  }

  if (!findTodaysSlot) {
    return <NoSlot />;
  }

  return (
    <CheckIn
      roomId={roomId}
      slot={findTodaysSlot}
      patient={patientQuery.data}
    />
  );
}
